import { CollectionInvoicePdf } from '../../clients/model';
import { StatementInvoice } from '../model';

export const STATEMENT_RESIDENTIAL_SUPPRESSED_TOOLTIP =
  'Home services clients are excluded from scheduled statements for this location. Change this under Client Eligibility in the statement configuration.';

export const STATEMENT_ADMIN_ONLY_TOGGLE_TOOLTIP = 'Only an admin can turn statements on/off.';

export const statementEnabledToggleTooltip = (residentialSuppressed: boolean, isCollectionsAdmin: boolean): string => {
  if (residentialSuppressed) return STATEMENT_RESIDENTIAL_SUPPRESSED_TOOLTIP;
  if (!isCollectionsAdmin) return STATEMENT_ADMIN_ONLY_TOGGLE_TOOLTIP;
  return '';
};

export const applyUploadedInvoicePdf = (
  invoices: StatementInvoice[],
  applyTo: string,
  pdf: CollectionInvoicePdf,
): StatementInvoice[] =>
  invoices.map((invoice) => (invoice.apply_to === applyTo ? { ...invoice, has_pdf: true, pdf } : invoice));

export const clearInvoicePdf = (invoices: StatementInvoice[], applyTo: string): StatementInvoice[] =>
  invoices.map((invoice) => (invoice.apply_to === applyTo ? { ...invoice, has_pdf: false, pdf: null } : invoice));

export const statementToggleErrorMessage = (error: unknown): string => {
  const data = (error as { response?: { data?: { errors?: string[]; error?: string } } })?.response?.data;
  return data?.errors?.[0] || data?.error || 'Failed to update statement status.';
};
